// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.filter-sort-bar{
    height: 95px;
    background-color: #8aaec6;

}

.filter-icon{
    position: relative;
    top: 30px;
    left: 55px;
    cursor: pointer;
}

.sort-icon-container{
    position: relative;
    top: -10px;
    left: 148px;
    cursor: pointer;
}

.filter-dropdown{
    position: relative;
    top: -54px;
    left: 220px;
    width: 465px;
    height: 40px;
    cursor: pointer;
    background-color: transparent;
    border: 0cap solid #ccc;
    border-radius: 0;
    font-size: 32px;
    padding: 0px 0px;
    padding-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/css/FilterSortBar.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,yBAAyB;;AAE7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["\r\n.filter-sort-bar{\r\n    height: 95px;\r\n    background-color: #8aaec6;\r\n\r\n}\r\n\r\n.filter-icon{\r\n    position: relative;\r\n    top: 30px;\r\n    left: 55px;\r\n    cursor: pointer;\r\n}\r\n\r\n.sort-icon-container{\r\n    position: relative;\r\n    top: -10px;\r\n    left: 148px;\r\n    cursor: pointer;\r\n}\r\n\r\n.filter-dropdown{\r\n    position: relative;\r\n    top: -54px;\r\n    left: 220px;\r\n    width: 465px;\r\n    height: 40px;\r\n    cursor: pointer;\r\n    background-color: transparent;\r\n    border: 0cap solid #ccc;\r\n    border-radius: 0;\r\n    font-size: 32px;\r\n    padding: 0px 0px;\r\n    padding-left: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
